const triggers = document.querySelectorAll('.tooltip-trigger');

function close(trigger) {
  trigger.setAttribute('aria-expanded', 'false');
  document.getElementById(trigger.getAttribute('aria-controls')).hidden = true;
}

function closeAll() {
  triggers.forEach(close);
}

triggers.forEach(trigger => {
  const panel = document.getElementById(trigger.getAttribute('aria-controls'));

  trigger.addEventListener('click', event => {
    event.stopPropagation();
    const wasExpanded = trigger.getAttribute('aria-expanded') === 'true';

    closeAll();

    if (!wasExpanded) {
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
  });
});

document.addEventListener('click', event => {
  if (!event.target.closest('.tooltip-container')) closeAll();
});

document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;

  const expanded = document.querySelector(
    '.tooltip-trigger[aria-expanded="true"]',
  );
  if (!expanded) return;

  // Escape is also a habit inside form fields: only take the focus back when it
  // sits on the trigger or inside the panel we are about to hide.
  const panel = document.getElementById(expanded.getAttribute('aria-controls'));
  const owned =
    document.activeElement === expanded ||
    panel.contains(document.activeElement);

  close(expanded);
  if (owned) expanded.focus();
});
